<template>
    <div class="crm-master-setup">
      <div class="setup-row">
        <div class="setup-section">
          <h3>Source</h3>
          <div class="input-group">
            <label for="source">Source:</label>
            <InputText id="source" v-model="sourceInput" placeholder="Enter source" class="w-100"/>
            <Button label="Add" @click="addMasterSetup('source')" class="p-button-success" />
          </div>
  
          <DataTable :value="sourceList" 
            class="p-datatable-responsive p-datatable-customers" 
            :filters="sourceFilters" 
            scrollable
            scrollHeight="150px">
            <template #empty>
              <div class="flex justify-center items-center h-10 text-gray-500">
                No record found
              </div>
            </template>
  
            <Column header="S.n">
              <template #body="slotProps">
                {{slotProps.index+1}}
              </template>
            </Column>
            <Column field="value" header="Source">
              <template #body="slotProps">
                <InputText v-if="editingId === slotProps.data.id && editingType === 'source'" 
                        v-model="editValue" />
                <span v-else>{{ slotProps.data.value }}</span>
              </template>
              <template #filter>
                <InputText type="text" class="p-inputtext p-component p-column-filter" v-model="sourceFilters['value']" />
              </template>
            </Column>
            <Column header="Actions" headerStyle="width: 11em">
              <template #body="slotProps">
                <Button v-if="editingId === slotProps.data.id && editingType === 'source'"
                      icon="pi pi-check" 
                      class="p-button-raised p-button-success"
                      @click="updateItem(slotProps.data.id)" />
                <Button v-else
                      icon="pi pi-pencil" 
                      class="p-button-raised p-button-success"
                      @click="startEditing(slotProps.data.id, slotProps.data.value, 'source')" />
                <Button icon="pi pi-trash" 
                      class="p-button-danger p-button-sm" 
                      @click="openDeleteModal(slotProps.data.id)" />
              </template>
            </Column>
          </DataTable>
        </div>
  
        <div class="setup-section">
          <h3>Ticket Status</h3>
          <div class="input-group">
            <label for="ticketStatus">Ticket Status:</label>
            <InputText id="ticketStatus" v-model="ticketStatusInput" placeholder="Enter ticket status" class="w-100"/>
            <Button label="Add" @click="addMasterSetup('ticketStatus')" class="p-button-success" />
          </div>
  
          <DataTable :value="ticketStatusList"
            class="p-datatable-responsive p-datatable-customers" 
            :filters="ticketStatusFilters"
            scrollable
            scrollHeight="150px" >
            <template #empty>
              <div class="flex justify-center items-center h-10 text-gray-500">
                No record found
              </div>
            </template>  
            <Column header="S.n">
              <template #body="slotProps">
                {{slotProps.index+1}}
              </template>
            </Column>
            <Column field="value" header="Ticket Status">
              <template #body="slotProps">
                <InputText v-if="editingId === slotProps.data.id && editingType === 'ticketStatus'" 
                        v-model="editValue" />
                <span v-else>{{ slotProps.data.value }}</span>
              </template>
              <template #filter>
                <InputText type="text" class="p-inputtext p-component p-column-filter" v-model="ticketStatusFilters['value']" />
              </template>
            </Column>
            <Column header="Actions" headerStyle="width: 11em">
              <template #body="slotProps">
                <Button v-if="editingId === slotProps.data.id && editingType === 'ticketStatus'"
                      icon="pi pi-check" 
                      class="p-button-raised p-button-success"
                      @click="updateItem(slotProps.data.id)" />
                <Button v-else
                      icon="pi pi-pencil" 
                      class="p-button-raised p-button-success"
                      @click="startEditing(slotProps.data.id, slotProps.data.value, 'ticketStatus')" />
                <Button icon="pi pi-trash" 
                      class="p-button-danger p-button-sm" 
                      @click="openDeleteModal(slotProps.data.id)" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
  
      <div class="setup-row">
        <div class="setup-section">
          <h3>Stage</h3>
          <div class="input-group">
            <label for="stage">Stage:</label>
            <InputText id="stage" v-model="stageInput" placeholder="Enter stage" class="w-100"/>
            <Button label="Add" @click="addMasterSetup('stage')" class="p-button-success" />
          </div>
  
          <DataTable :value="stageList" 
            class="p-datatable-responsive p-datatable-customers" 
            :filters="stageFilters"
            scrollable
            scrollHeight="150px">
            <template #empty>
              <div class="flex justify-center items-center h-10 text-gray-500">
                No record found
              </div>
            </template>  
            <Column header="S.n">
              <template #body="slotProps">
                {{slotProps.index+1}}
              </template>
            </Column>
            <Column field="value" header="Stage">
              <template #body="slotProps">
                <InputText v-if="editingId === slotProps.data.id && editingType === 'stage'" 
                        v-model="editValue" />
                <span v-else>{{ slotProps.data.value }}</span>
              </template>
              <template #filter>
                <InputText type="text" class="p-inputtext p-component p-column-filter" v-model="stageFilters['value']" />
              </template>
            </Column>
            <Column header="Actions" headerStyle="width: 11em">
              <template #body="slotProps">
                <Button v-if="editingId === slotProps.data.id && editingType === 'stage'"
                      icon="pi pi-check" 
                      class="p-button-raised p-button-success"
                      @click="updateItem(slotProps.data.id)" />
                <Button v-else
                      icon="pi pi-pencil" 
                      class="p-button-raised p-button-success"
                      @click="startEditing(slotProps.data.id, slotProps.data.value, 'stage')" />
                <Button icon="pi pi-trash" 
                      class="p-button-danger p-button-sm" 
                      @click="openDeleteModal(slotProps.data.id)" />
              </template>
            </Column>
          </DataTable>
        </div>
  
        <div class="setup-section">
          <h3>Priority</h3>
          <div class="input-group">
            <label for="priority">Priority:</label>
            <InputText id="priority" v-model="priorityInput" placeholder="Enter priority" class="w-100"/>
            <Button label="Add" @click="addMasterSetup('priority')" class="p-button-success" />
          </div>
  
          <DataTable :value="priorityList" 
            class="p-datatable-responsive p-datatable-customers" 
            :filters="priorityFilters"
            scrollable
            scrollHeight="150px">
            <template #empty>
              <div class="flex justify-center items-center h-10 text-gray-500">
                No record found
              </div>
            </template>  
            <Column header="S.n">
              <template #body="slotProps">
                {{slotProps.index+1}}
              </template>
            </Column>
            <Column field="value" header="Priority">
              <template #body="slotProps">
                <InputText v-if="editingId === slotProps.data.id && editingType === 'priority'" 
                        v-model="editValue" />
                <span v-else>{{ slotProps.data.value }}</span>
              </template>
              <template #filter>
                <InputText type="text" class="p-inputtext p-component p-column-filter" v-model="priorityFilters['value']" />
              </template>
            </Column>
            <Column header="Actions" headerStyle="width: 11em">
              <template #body="slotProps">
                <Button v-if="editingId === slotProps.data.id && editingType === 'priority'"
                      icon="pi pi-check" 
                      class="p-button-raised p-button-success"
                      @click="updateItem(slotProps.data.id)" />
                <Button v-else
                      icon="pi pi-pencil" 
                      class="p-button-raised p-button-success"
                      @click="startEditing(slotProps.data.id, slotProps.data.value, 'priority')" />
                <Button icon="pi pi-trash" 
                      class="p-button-danger p-button-sm" 
                      @click="openDeleteModal(slotProps.data.id)" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="confirmDelete" />
    </div>
  </template>
  
  <script>
  import Column from 'primevue/column'
  import DataTable from 'primevue/datatable'
  import Dialog from '../../layout/dialog'
  import Button from 'primevue/button'
  import InputText from 'primevue/inputtext'
  
  export default {
    name: 'CrmMasterSetup',
    data() {
      return {
        sourceInput: '',
        ticketStatusInput: '',
        stageInput: '',
        priorityInput: '',
        editingId: null,
        editingType: null,
        editValue: '',
        dialogShow: false,
        deleteItemId: null,
        sourceFilters: {},
        ticketStatusFilters: {},
        stageFilters: {},
        priorityFilters: {},
        setupTypeEnum: 2
      }
    },
    computed: {
      masterSetupList() {
        return this.$store.state.users.masterSetupList
      },
      sourceList() {
        return this.masterSetupList.filter(item =>
          item.name === 'source'
        )
      },
      ticketStatusList() {
        return this.masterSetupList.filter(item =>
          item.name === 'ticketStatus'
        )
      },
      stageList() {
        return this.masterSetupList.filter(item =>
          item.name === 'stage'
         )
      },
      priorityList() {
        return this.masterSetupList.filter(item =>
          item.name === 'priority'
        )
      }
    },
    methods: {
      addMasterSetup(name) {
        let value = ''
        switch (name) {
          case 'source':
            value = this.sourceInput
            this.sourceInput = ''
            break
          case 'ticketStatus':
            value = this.ticketStatusInput
            this.ticketStatusInput = ''
            break
          case 'stage':
            value = this.stageInput
            this.stageInput = ''
            break
          case 'priority':
            value = this.priorityInput
            this.priorityInput = ''
            break
        }
        if (!value.trim()) {
          this.$toast.add({severity: 'error', summary: '', detail: `Please enter a valid ${name}`, life: 10000})
          return
        }
        const payload = {
          setupType: 'Crm',
          name: name,
          value: value
        }
        this.$store.dispatch('createMasterSetup', payload)
      },
      startEditing(id, value, type) {
        this.editingId = id
        this.editingType = type
        this.editValue = value
      },
      updateItem(id) {
        if (!this.editValue.trim()) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please enter a valid value', life: 10000})
          return
        }
        const payload = {
          id: id,
          setupType: 'Crm',
          name: this.editingType,
          value: this.editValue
        }
        this.$store.dispatch('updateMasterSetup', payload)
          .then(() => {
            this.editingId = null
            this.editingType = null
            this.editValue = ''
          })
      },
      openDeleteModal(id) {
        this.dialogShow = true
        this.deleteItemId = id
      },
      confirmDelete(value) {
        if (value.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
          this.dialogShow = true
          return
        }
        const payload = {
          id: this.deleteItemId,
          deleteReason: value
        }
        this.$store.dispatch('deleteMasterSetup', payload)
          .then((response) => {
            if (response.data && response.data.status === 'SUCCESS') {
              this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
            } else {
              this.$toast.add({severity: 'error', summary: '', detail: response.data ? response.data.message : 'Delete failed', life: 10000})
            }
            this.dialogShow = false
          })
          .catch(() => {
            this.$toast.add({severity: 'error', summary: '', detail: 'An error occurred while deleting', life: 10000})
            this.dialogShow = false
          })
      },
      cancel() {
        this.dialogShow = false
      },
      loadData() {
        this.$store.dispatch('loadMasterSetupList', 'Crm')
          .catch(error => {
            console.error('Error loading master setup data:', error)
            this.$toast.add({severity: 'error', summary: '', detail: 'Failed to load setup data', life: 10000})
          })
      }
    },
    components: {
      Column,
      DataTable,
      Dialog,
      Button,
      InputText
    },
    mounted() {
      this.loadData()
    }
  }
  </script>
  
  <style scoped>
.crm-master-setup {
  padding: 20px;
  background-color: #f8f9fa;
}

.setup-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.setup-section {
  flex: 1;
  background-color: white;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.setup-section h3 {
  margin-bottom: 15px;
  color: #555;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
}

.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.w-100 {
  width: 100%;
  max-width: 300px;
}

.input-group label {
  min-width: 100px;
  font-weight: bold;
}

@media screen and (max-width: 992px) {
  .setup-row {
    flex-direction: column;
  }
}

:deep(.p-button) {
  margin-right: 0.5rem;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// crmMasterSetup.vue?8569d0bc